import React, { Component } from 'react';
import './NowLiveText.scss';

class NowLiveText extends Component {
  componentDidUpdate() {
    const { node } = this;
    const containerPaddingX =
      parseFloat(window.getComputedStyle(node).paddingLeft) +
      parseFloat(window.getComputedStyle(node).paddingRight);
    const containerWidth = node.clientWidth - containerPaddingX;
    const marqueeChildren = node.getElementsByClassName('marquee');

    for (let i = marqueeChildren.length - 1; i >= 0; i -= 1) {
      // eslint-disable-line
      const mChild = marqueeChildren[i];
      // If text is larger then container, make it a marquee
      if (mChild.clientWidth > containerWidth) {
        mChild.style.setProperty(
          '--marquee-size',
          `${containerWidth - mChild.clientWidth}px`
        );
        let duration = (mChild.clientWidth - containerWidth) / 3.33;
        if (duration > 20) {
          duration = 20;
        } else if (duration < 7) {
          duration = 7;
        }
        mChild.style.setProperty('--marquee-duration', `${duration}s`);
        mChild.classList.add('active');
      } else {
        mChild.style.removeProperty('--marquee-size');
        mChild.style.removeProperty('--marquee-duration');
        mChild.classList.remove('active');
      }
    }
  }

  render() {
    const { state } = this.props; // eslint-disable-line
    const { subText } = state;
    const subTextMapped = subText.split('\n').map(line => (
      <div className="marquee" key={line}>
        <span>{line}</span>
      </div> //
    ));

    return (
      <div
        className="NowLiveText"
        ref={n => {
          this.node = n;
        }}
      >
        <span className="MainText">
          <div className="marquee">
            <span>{state.mainText}</span>
          </div>
        </span>
        <span className="SubText">{subTextMapped}</span>
      </div>
    );
  }
}

export default NowLiveText;
